export enum EntityTableFiltersTypes {
  Gender = "gender",
  Standard = "standard",
  AgeGroup = "ageGroup",
  Discipline = "discipline",
  Status = "status",
}
